import { IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { fas, fal, far, fad, fak } from "@awesome.me/kit-cae4660dd3/icons";
import IconLibraryEnum from "../../enums/icon-library.enum";

// Copied from student ux-component-library with themes removed
interface ConfigType {
  defaults: {
    iconLibrary: IconLibraryEnum;
  };
  iconLibrary: {
    regular: {
      style: IconPrefix;
      pack: any;
    };
    light: {
      style: IconPrefix;
      pack: any;
    };
    duotone: {
      style: IconPrefix;
      pack: any;
    };
    solid: {
      style: IconPrefix;
      pack: any;
    };
    kit: {
      style: IconPrefix;
      pack: any;
    };
  };
}

const config: ConfigType = {
  defaults: {
    iconLibrary: IconLibraryEnum.SOLID
  },
  iconLibrary: {
    regular: {
      style: "far",
      pack: far
    },
    light: {
      style: "fal",
      pack: fal
    },
    duotone: {
      style: "fad",
      pack: fad
    },
    solid: {
      style: "fas",
      pack: fas
    },
    //for custom icons in a kit
    kit: {
      style: "fak",
      pack: fak
    }
  }
};

export default config;
